export default __webpack_public_path__ + "static/media/earth.20f51a8f.svg";